import { useRootStore } from "Store/RootStore";
import { addAppItem, overflowItem, sideBarItems } from "./AppLeftBarMenuItems";

export const useSideBarItems = () => {
    const appStore = useRootStore("AppSettingStore");
    const filteredSidebarItems = sideBarItems.filter((item) => appStore.appModels.some((app) => item.isV1 || app.path === item.routeName));

    return {
        sideBarItems: filteredSidebarItems,
        addAppItem: addAppItem,
        overflowItem: overflowItem
    };
};
